import styled, { css } from "styled-components";
import React from "react";
import {
  BOTTOM_NAVIGATOR,
  FACEBOOK_LINK,
  INSTAGRAM_LINK,
  IS_WEB_VIEW,
  LINKEDIN_LINK,
  TELEGRAM_ANNOUNCEMENTS_LINK,
  WEBSITE_LINK,
  YOUTUBE_LINK,
} from "common/constants";
import {
  ContactFacebook,
  ContactInstagram,
  ContactLinkedin,
  ContactTelegram,
  ContactWeb,
  ContactYoutube,
} from "common/Icons/Icons";
import InfoCircleOutlined from "@ant-design/icons/InfoCircleOutlined";
import QuestionCircleOutlined from "@ant-design/icons/QuestionCircleOutlined";
import QrPopover from "common/Sider/QrPopover";
import Link from "common/Typography/Link";
import { showIntercomSpace } from "utils/misc.tsx";

const SocialMedia = () => {
  return (
    <>
      <HelpWrapper>
        <HelpLink onClick={() => showIntercomSpace("help")}>
          <InfoCircleOutlined style={{ marginRight: 4 }} />
          How to Use
        </HelpLink>
        <HelpLink onClick={() => showIntercomSpace("home")}>
          <QuestionCircleOutlined style={{ marginRight: 4 }} />
          Support
        </HelpLink>
      </HelpWrapper>
      <IconsButtonsWrapper>
        <FlexWrapper style={{ padding: "0px 16px 0 16px" }}>
          <IconLink href={TELEGRAM_ANNOUNCEMENTS_LINK} target="_blank">
            <StyledTelegram />
          </IconLink>
          <IconLink href={INSTAGRAM_LINK} target="_blank">
            <StyledInstagram />
          </IconLink>
          <IconLink href={FACEBOOK_LINK} target="_blank">
            <StyledFacebook />
          </IconLink>
          <IconLink href={LINKEDIN_LINK} target="_blank">
            <StyledLinkedin />
          </IconLink>
          <IconLink href={WEBSITE_LINK} target="_blank">
            <StyledGlobal />
          </IconLink>
          <IconLink href={YOUTUBE_LINK} target="_blank">
            <StyledYoutube />
          </IconLink>
        </FlexWrapper>
        {!IS_WEB_VIEW && (
          <FlexWrapper style={{ gridGap: 4, marginTop: 12 }}>
            <QrPopover isAppStore={true} />
            <QrPopover isAppStore={false} />
          </FlexWrapper>
        )}
      </IconsButtonsWrapper>
    </>
  );
};

export default SocialMedia;

const HelpLink = styled(Link)`
  color: ${(p) => p.theme.colors.secondaryGrey} !important;
  font-size: ${(p) => p.theme.typography.fontSizes.S};
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 8px;
  &:not(:last-child) {
    border-right: ${(p) => p.theme.borders.lightest};
  }
  @media (min-width: ${BOTTOM_NAVIGATOR}) {
    &:hover {
      color: ${(p) => p.theme.colors.primaryBlue} !important;
    }
  }
`;
const HelpWrapper = styled.div`
  display: flex;
  align-items: center;
  border-top: ${(p) => p.theme.borders.lightest};
`;

const IconsButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding: ${IS_WEB_VIEW ? 8 : 16}px 12px;
  border-top: ${(p) => p.theme.borders.lightest};
`;

const FlexWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const IconLink = styled(Link)`
  color: ${(p) => p.theme.colors.secondaryGrey} !important;
  text-decoration: none;
  @media (min-width: ${BOTTOM_NAVIGATOR}) {
    &:hover {
      color: ${(p) => p.theme.colors.primaryBlue} !important;
    }
  }
`;
const iconCss = css`
  font-size: 16px;
  transform: translate(0, 3px);
  fill: ${(p) => p.theme.colors.secondaryGrey} !important;
  @media (min-width: ${BOTTOM_NAVIGATOR}) {
    &:hover {
      fill: ${(p) => p.theme.colors.primaryBlue} !important;
    }
  }
`;
const StyledTelegram = styled(ContactTelegram)`
  ${iconCss};
`;
const StyledInstagram = styled(ContactInstagram)`
  ${iconCss};
`;
const StyledFacebook = styled(ContactFacebook)`
  ${iconCss};
`;
const StyledLinkedin = styled(ContactLinkedin)`
  ${iconCss};
  font-size: 18px;
`;
const StyledGlobal = styled(ContactWeb)`
  ${iconCss};
`;
const StyledYoutube = styled(ContactYoutube)`
  ${iconCss};
`;
